import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import uploadFiletoServer from '../api/uploadFiletoServer';
import { NotificationContext } from '../context/NotificationProvider';

const FileUploader = ({ setReport }) => {
  const hiddenFileInput = React.useRef(null);
  const { sendNotification } = useContext(NotificationContext);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadFile, { isLoading }] = useMutation(uploadFiletoServer, {
    onSuccess: (report) => {
      setUploadedFile(null);
      setReport(report);
    },
    onError: (error) => {
      sendNotification({
        type: 'warning',
        message: error.response?.statusText,
      });
    },
  });

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    setUploadedFile(event.target.files[0]);
    event.target.value = null;
  };

  const handleUploadFile = async () => {
    if (uploadedFile) {
      if (!uploadedFile.name.match(/\.csv$/i))
        sendNotification({
          type: 'warning',
          message: 'Only CSV files allowed!',
        });
      else {
        await uploadFile(uploadedFile);
      }
    } else
      sendNotification({ type: 'warning', message: 'Please choose a file!' });
  };
  return (
    <>
      <p className="text-xl font-bold uppercase">File Upload</p>
      <div className="text-center p-10">
        <div className="rounded-md shadow overflow-hidden border-2 border-primary inline-flex mb-10">
          <button
            type="button"
            onClick={handleClick}
            className="bg-white text-gray-500 w-84 hover:bg-yellow-100 transition-colors duration-500 p-2"
          >
            <input
              type="file"
              ref={hiddenFileInput}
              onChange={handleChange}
              style={{
                display: 'none',
              }} /* Make the file input element invisible */
            />
            {uploadedFile ? uploadedFile.name : 'Choose File...'}
          </button>
          <button
            type="button"
            className="btn-basic px-3 py-2"
            onClick={handleUploadFile}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <FontAwesomeIcon icon="circle-notch" spin className="mr-2" />
                Uploading
              </>
            ) : (
              <>
                <FontAwesomeIcon icon="folder" className="mr-2" />
                Upload
              </>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

FileUploader.propTypes = PropTypes.func.isRequired;
export default FileUploader;
